// BSV CHANGES
import {call, put, takeLatest} from 'redux-saga/effects';
import {NetworkService, ToasterService} from '@app/services';
import {
  postDownloadRequest,
  postDownloadSuccess,
  postDownloadFailure,
  HQPositionRequest,
  HQPositionSuccess,
  HQPositionFailure,
} from './slice';
import {API_PATH} from '@app/common/constants';
import {ToastType} from '@app/services/toaster';

const downloadFile = async (url: string, fileName: string) => {
  try {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error downloading the file', error);
  }
};

function* handleHQPosition(action: ReturnType<typeof HQPositionRequest>): any {
  try {
    const url = API_PATH.reportsDownload.HQPositions;
    const res = yield call(NetworkService.post, url, action.payload); 
    yield put(HQPositionSuccess(res.data));
  } catch (error: any) {
    console.error("Distance API Error:", error);
    yield put(HQPositionFailure(error.message));
  }
}

function* handlePostDownload(
  action: ReturnType<typeof postDownloadRequest>,
): any {
  try {
    const {selectedReportType, ...restPayload} = action.payload;
    const url = `${API_PATH.reportsDownload.downloadReports}/${selectedReportType}`;
    const res = yield call(NetworkService.post, url, restPayload); 
    if (res?.data?.isCreated) {
      downloadFile(res.data.message,'')
      yield put(postDownloadSuccess());
      ToasterService.showToaster(
        'Records downloaded successfully!',
        ToastType.SUCCESS,
      );
    } else {
      yield put(postDownloadFailure('ERROR'));
      ToasterService.showToaster(
        'Something went wrong while downloading.',
        ToastType.ERROR,
      );
    }
  } catch (error: any) {
    yield put(postDownloadFailure(error.message));
    ToasterService.showToaster(
      'Something went wrong while downloading.',
      ToastType.ERROR,
    );
  }
}

export default function* expenseReportsSaga() {
  yield takeLatest(HQPositionRequest.type, handleHQPosition);
  yield takeLatest(postDownloadRequest.type, handlePostDownload);
}
